import { isRESTAPIError, type RESTAPIError } from './RESTAPIError';

const MAX_CAUSE_DEPTH = 5;

export function findRESTAPIError(error: unknown): RESTAPIError | undefined {
  let current = error;

  for (let depth = 0; depth <= MAX_CAUSE_DEPTH && current; depth++) {
    if (isRESTAPIError(current)) {
      return current;
    }

    current = current instanceof Error ? current.cause : undefined;
  }

  return undefined;
}
